import React from 'react'
import { StaticQuery } from 'gatsby';
import { graphql } from 'gatsby';
import showdown from 'showdown';
const converter = new showdown.Converter()

const networksImages = {
    facebook: {
        image: "/img/bdz-facebook.png",
        alt: "facebook"
    },
    instagram: {
        image: "/img/bdz-instagram.png",
        alt: "instagram"
    },
    twitter: {
        image: "/img/bdz-twitter.png",
        alt: "twitter"
    },
    youtube: {
        image: "/img/bdz-youtube.png",
        alt: "youtube web"
    }
}

const SocialNetworks = ({
    data
}) => {
    const {
        address,
        phone,
        email,
        networks
    } = data.markdownRemark.frontmatter;

    return (
        <>
            <h5 class="text-white font-weight-bold mb-4">Contácto</h5>
            <div>
                <div className="d-flex align-items-center mb-3">
                    <img src="/img/bdz-phone-icon.png" alt="sd" className="img-fluid mr-3" />
                    <span
                        className="text-muted text-white">
                        {phone}
                    </span>
                </div>
                <div className="d-flex align-items-center mb-3">
                    <img src="/img/bdz-email-icon.png" alt="sd" className="img-fluid mr-3" />
                    <span
                        className="text-muted">
                        {email}
                    </span>
                </div>
                <div className="d-flex align-items-center mb-5">
                    <img src="/img/bdz-location-icon.png" alt="sd" className="img-fluid mr-3" />
                    <div
                        className="text-muted"
                        dangerouslySetInnerHTML={{ __html: converter.makeHtml(address) }} />
                </div>
            </div>
            <div
                className="d-flex align-items-center">
                {
                    Object.keys(networks).map((key, index) => (
                        <a
                            key={`network${index}`}
                            target="_blank"
                            href={networks[key]}
                            className="mx-auto ml-md-0 mr-4 mr-lg-5">
                            <img
                                className="img-fluid social-effect"
                                src={networksImages[key].image}
                                alt={networksImages[key].alt} />
                        </a>
                    ))
                }
            </div>
        </>
    )
}


export default props => (
    <StaticQuery
        query={graphql`
        query SocialNetworks {
            markdownRemark(frontmatter: { templateKey: { eq: "contacts" } }) {
                frontmatter {
                  email
                  phone
                  address
                  networks { 
                      facebook
                      instagram
                      twitter
                      youtube
                  }
                }
              }
        }
      `}
        render={(data, count) => <SocialNetworks data={data} {...props} />}
    />
)